export const config = {
  title: "Master Fix | Handyman Services & Cleaning | Las Vegas, NV",
  meta: {
    description:
      "Master Fix provides expert handyman services and professional cleaning in Las Vegas, NV. Home repairs, maintenance, and spotless cleaning solutions. Special discounts for Veterans, elderly, and disabled customers.",
    keywords: [
      "Master Fix",
      "Handyman Las Vegas",
      "Home Repair Vegas",
      "Cleaning Services Vegas",
      "Home Maintenance",
      "Las Vegas Handyman",
      "Professional Cleaning",
      "Veterans Discount"
    ],
    author: "Master Fix",
    canonicalUrl: "https://masterfixvegas.com/",
    imageURL: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
  },
  sections: {
    header: {
      businessName: "Master Fix",
    },
    sectionB: {
      heroTitle: "Expert Handyman Services & Professional Cleaning",
      heroSubtitle: "Your Trusted Home Repair & Maintenance Partner in Las Vegas",
      learnAboutText: "Get Your Free Estimate",
      phoneNumber: "7027206165",
      phoneLabel: "(702) 720-6165",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
      cardData: [
        {
          title: "Home Repairs",
          description:
            "Expert solutions for all your home repair needs with professional craftsmanship and reliable service.",
        },
        {
          title: "Cleaning Services",
          description:
            "Professional cleaning services for a spotless home, ensuring your space is pristine and comfortable.",
        },
        {
          title: "Special Discounts",
          description:
            "We honor our community with special discounts for Veterans, the elderly, and disabled customers.",
        },
      ],
      description:
        "Master Fix is your trusted partner for expert handyman services and professional cleaning in Las Vegas. We provide reliable home repair solutions and spotless cleaning services.",
    },
    sectionC: {
      servicesTitle: "Our Expert Services",
      servicesDescription:
        "Professional handyman and cleaning services designed to keep your home in perfect condition. We offer special discounts for Veterans, elderly, and disabled customers.",
      cards: [
        {
          title: "Home Repair Services",
          description:
            "Comprehensive home repair solutions including plumbing fixes, electrical work, carpentry, drywall repair, and general maintenance services.",
          imageSrc: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Home Repair Services",
        },
        {
          title: "Professional Cleaning",
          description:
            "Thorough cleaning services for residential properties including deep cleaning, regular maintenance cleaning, and specialized cleaning solutions.",
          imageSrc: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Professional Cleaning Services",
        },
        {
          title: "Maintenance Services",
          description:
            "Regular home maintenance services to prevent costly repairs and keep your property in excellent condition year-round.",
          imageSrc: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Home Maintenance Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Plumbing Repairs",
        "Electrical Work",
        "Carpentry Services",
        "Drywall Repair",
        "Painting Services",
      ],
    },
    sectionD: {
      aboutTitle: "About Master Fix",
      aboutImage: {
        src: "https://d13cw1lxlociqy.cloudfront.net/hi949wy8crs085nez98jfydydkaq",
        alt: "Master Fix Team",
      },
      aboutText: [
        "Master Fix is Las Vegas's trusted handyman and cleaning service provider, dedicated to delivering expert solutions for all your home repair and maintenance needs. Our team of skilled professionals combines years of experience with a commitment to quality workmanship.",
        "We take pride in serving our community and honoring those who have served us. That's why we offer special discounts for Veterans, the elderly, and disabled customers. Whether you need home repairs or professional cleaning services, Master Fix is here to make your home spotless and functional.",
      ],
    },
    sectionE: {
      profileImage: "https://jobber.s3.amazonaws.com/work_configuration_logos/1736625/original/Master_Fix_Logo_Color.PNG?1747505506",
      profileAlt: "Master Fix Las Vegas",
      businessName: "Master Fix",
      contact: {
        phone: "7027206165",
        phoneLabel: "(702) 720-6165",
        email: "masterfixvegas@gmail.com",
        website: "https://masterfixvegas.com/",
        address: "Las Vegas, NV",
      },
      socialMedia: {
        instagram: "https://www.instagram.com/masterfixvegas",
      },
    },
    sectionF: {
      address: "Las Vegas, NV",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d408847.5123456789!2d-115.1398296!3d36.1699412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80beb782a4f57dd1%3A0x3accd5e6d5b379a3!2sLas%20Vegas%2C%20NV!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;